import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Switch,
  TextField,
  Typography,
  colors
} from '@material-ui/core';

import SuccessSnackbar from '../SuccessSnackbar';

const useStyles = makeStyles(theme => ({
  root: {},
  saveButton: {
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  }
}));

const GeneralSettings = props => {
  const { profile, className, ...rest } = props;

  const classes = useStyles();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [values, setValues] = useState({
    firstName: profile.firstName,
    lastName: profile.lastName,
    email: profile.email,
    phone: profile.phone,
    state: profile.state,
    country: profile.country,
    isPublic: profile.isPublic,
    canHire: profile.canHire
  });

  const handleChange = event => {
    event.persist();

    setValues({
      ...values,
      [event.target.name]:
        event.target.type === 'checkbox'
          ? event.target.checked
          : event.target.value
    });
  };

  const handleSubmit = event => {
    event.preventDefault();
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <form onSubmit={handleSubmit}>
        <CardHeader title="Profile" />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={4}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              {profile.name && <TextField
                fullWidth
                helperText="Please specify the first name"
                label="User Name"
                name="firstName"
                onChange={handleChange}
                required
                value={profile.username}
                variant="outlined"
                disabled
              />}
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
            {profile.name &&   <TextField
                fullWidth
                label="Name"
                name="lastName"
                onChange={handleChange}
                required
                value={profile.name}
                variant="outlined"
                disabled
              />}
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
            {profile.mobile &&   <TextField
                fullWidth
                label="Phone Number"
                name="phone"
                onChange={handleChange}
                type="text"
                value={profile.mobile}
                variant="outlined"
                disabled
              />}
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <Typography variant="h6">Profile Status</Typography>
             {profile.status ? <Switch
                checked={true}
                color="secondary"
                edge="start"
                name="isPublic"
                onChange={handleChange}
              /> :  <Switch
              checked={false}
              color="secondary"
              edge="start"
              name="isPublic"
              onChange={handleChange}
            />}
            </Grid>
          </Grid>
        </CardContent>
      </form>
      <SuccessSnackbar
        onClose={handleSnackbarClose}
        open={openSnackbar}
      />
    </Card>
  );
};

GeneralSettings.propTypes = {
  className: PropTypes.string,
  profile: PropTypes.object.isRequired
};

export default GeneralSettings;
